/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createIngestAffiliateCustomerOrchestrationResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type IngestAffiliateCustomerOrchestrationResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Guid, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /ingests/affiliate-customers
 */
export interface AffiliateCustomersRequestBuilder extends BaseRequestBuilder<AffiliateCustomersRequestBuilder> {
    /**
     * IngestAffiliateCustomers
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<IngestAffiliateCustomerOrchestrationResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<AffiliateCustomersRequestBuilderPostQueryParameters> | undefined) : Promise<IngestAffiliateCustomerOrchestrationResult | undefined>;
    /**
     * IngestAffiliateCustomers
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<AffiliateCustomersRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * IngestAffiliateCustomers
 */
export interface AffiliateCustomersRequestBuilderPostQueryParameters {
    affiliateId?: Guid;
    verifyOnly?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const AffiliateCustomersRequestBuilderUriTemplate = "{+baseurl}/ingests/affiliate-customers?affiliateId={affiliateId}{&verifyOnly*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const AffiliateCustomersRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: AffiliateCustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createIngestAffiliateCustomerOrchestrationResultFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
